exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mobile__container__19cXa{background-color:-wix-colors-backgroundColor;box-sizing:border-box}", ""]);

// exports
exports.locals = {
	"container": "mobile__container__19cXa"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/layouts/mobile/mobile.styl
// module id = 2931
// module chunks = 1